module.exports = __webpack_public_path__ + "static/media/ourClients.f033686e.png";